// Module
var code = "<div class=\"css-grid-manager\" :style=\"gridStyle()\">\n  <cs-widget v-for=\"widget in dashboard.widgets\" :key=\"widget.id\" :widget=\"widget\" :style=\"gridWidgetStyle(widget)\"></cs-widget>\n</div>\n";
// Exports
module.exports = code;